import React from 'react'
import { useTemplateRenderQuery } from '../../store/Reducer/templateApis';

const TemplateRender = () => {
    const { data, isLoading, error } = useTemplateRenderQuery(); 

    // Check for loading state
    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Check for errors
    if (error) {
        return <div>Error: {error.message}</div>;
    }

    // Check if data is undefined or empty
    if (!data || Object.keys(data).length === 0) {
        return <div>No data available</div>;
    }

    return (
        <div className="w-full h-full">
            <h1>Template Render</h1>
            {/* <div>{ ReactHtmlParser(data) }</div>; */}
        </div>
    );
}

export default TemplateRender